import PropTypes from 'prop-types';
import { BrandMark } from './logo/Brand';
import LinearProgress from '@mui/material/LinearProgress';

export default function Loader({ fullScreen = false }) {
  if (!fullScreen) {
    return <LinearProgress aria-label="Loading page" sx={{ position: 'fixed', top: 0, left: 0, right: 0, height: 3, zIndex: 2001, pointerEvents: 'none' }} />;
  }

  return (
    <div className="xc-loading" role="status" aria-live="polite" aria-label="Loading XchanEcom workspace">
      <div className="xc-loading-brand">
        <span className="xc-loading-mark"><BrandMark size={52} /></span>
        <div className="xc-loading-name">Xchan<span>Ecom</span></div>
      </div>
      <div className="xc-loading-track" aria-hidden="true" />
      <p className="xc-loading-message">Opening your workspace…</p>
    </div>
  );
}
Loader.propTypes = { fullScreen: PropTypes.bool };
